import { useAxios } from "@hooks";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useGetExamRooms = () => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchExamRooms = async (): Promise<any[]> => {
        try {
            const { data } = await axios.get("/api/examroom");
            return data;
        } catch (error) {
            throw new Error(t("messages.error.getExamRooms"));
        }
    }

    return useQuery({ queryKey: ["examRooms"], queryFn: fetchExamRooms, staleTime: Infinity })
}